import { PropsWithChildren } from 'react';
import styles from './BasicBanner.module.scss';
import Layout from '../../../common/Layout/Layout';
import { classes } from '../../../../lib/utils/cssUtils';

type BasicBannerVariant = 'primaryNavy' | 'primaryBoostedBlue';

type BasicBannerProps = PropsWithChildren<{
  variant: BasicBannerVariant;
  background?: { variant: 'Half'; color: 'SecondaryPurple' };
}>;

const BasicBanner = ({ variant, background, children }: BasicBannerProps) => {
  return (
    <div
      className={classes(styles.bannerWrapper, styles[variant], {
        [styles[`bg${background?.variant}${background?.color}`]]: !!background,
      })}
    >
      <Layout>
        <div className={styles.bannerContent}>
          <div className={styles.backgroundWrapper}>{children}</div>
        </div>
      </Layout>
    </div>
  );
};

export default BasicBanner;
